import { render, staticRenderFns } from "./g-dialog.vue?vue&type=template&id=3cf6d0b5&"
import script from "./g-dialog.vue?vue&type=script&lang=js&"
export * from "./g-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports